/**
 * @file        src/components/FaviconManager.jsx
 * @description Applies the favicon configured in admin Site Settings across the
 *              site. Renders nothing; on mount (and whenever the configured URL
 *              changes) it points the document's <link rel="icon"> (and the Apple
 *              touch icon) at the uploaded favicon. When none is configured it
 *              leaves the static default in index.html untouched.
 * @author      Kinetika Labs
 * @created     2026-07-23
 * @changelog
 *   - 2026-07-23 Claude — Initial (favicon from Site Settings).
 */
import { useEffect } from 'react';
import { useCompanyInfo } from '../hooks/useCompanyInfo.js';

export default function FaviconManager() {
  const { faviconUrl } = useCompanyInfo();

  useEffect(() => {
    if (!faviconUrl) return;
    const ensure = (rel) => {
      let link = document.head.querySelector(`link[rel='${rel}']`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      return link;
    };
    ensure('icon').href = faviconUrl;
    ensure('apple-touch-icon').href = faviconUrl;
  }, [faviconUrl]);

  return null;
}
